import axios from 'axios'

const config = require('../config.js')

const API_URL = config.API_URL

export const login = (payload) => {
    return axios.post(`${API_URL}/authen`,payload)
}